import {ForgotPasswordUserCommand, type ForgotPasswordUserInput} from '@perfectpost/perfect-post-common';
import {useMutation} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {authKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Demande d'un code de réinitialisation (appel non authentifié).
 *
 * Remplace le `send(new ForgotPasswordUserCommand({email, locale}))` de `Reset`.
 */
export function useForgotPasswordMutation(options: MutationUiOptions = {}) {
  return useMutation({
    ...options,
    mutationKey: [...authKeys.mutations(), 'forgotPassword'],
    mutationFn: (input: ForgotPasswordUserInput): Promise<void> => sendOrThrow(new ForgotPasswordUserCommand(input)),
  });
}
